module.exports = __webpack_public_path__ + "static/Yeti-fb4aed32bae72c309cac616827c8ab17.jpg";